// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cz2__ai-modal__upload{width:100%;height:100%;display:flex;flex-direction:column;justify-content:center;background-color:#fff;padding:48px 24px 24px 24px}@media(min-width:1024px){.cz2__ai-modal__upload{padding:24px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
